module.exports = __webpack_public_path__ + "static/rug_of_smothering-c72e36542a45bc28e3c385e71915619e.jpg";